import { Column } from 'primereact/column'
import { DataTable } from 'primereact/datatable'
import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { tableCellCentered } from '../../../../assets/js/styles'
import {
  Btn,
  Cnpj,
  CustomCheckbox,
  CustomDataTableHeader,
  CustomPanel,
  PageHeader,
  ThreeDots,
} from '../../../../components'
import {
  hideLoadingBox,
  showLoadingBox,
  showMessageBox,
} from '../../../../store/actions/system.actions'
import useTransportadora, { LOAD_MESSAGE } from './TransportadoraHook'
import TransportadoraModal from './TransportadoraModal/TransportadoraModal'

function Transportadora({ dispatch, history, selectedTp }) {
  const { state, localDispatch } = useTransportadora()

  useEffect(() => {
    localDispatch.onInit(selectedTp)
  }, [selectedTp])

  useEffect(() => {
    switch (state.loadingMessage) {
      case LOAD_MESSAGE.NONE:
        dispatch(hideLoadingBox())
        break

      case LOAD_MESSAGE.INITIAL_FETCH:
        dispatch(showLoadingBox('Aguarde...', state.loadingMessage))
        localDispatch.getTransportadoras(selectedTp)
        break

      case LOAD_MESSAGE.DELETE_TRANSPORTADORA:
        dispatch(showLoadingBox('Aguarde...', state.loadingMessage))
        localDispatch.deleteTransportadora(state.selectedTransportadora.id, selectedTp)
        break

      case LOAD_MESSAGE.SUCCESS_DELETE:
        dispatch(hideLoadingBox())
        dispatch(showMessageBox(state.loadingMessage, null))
        break

      default:
        break
    }
  }, [state.loadingMessage])

  useEffect(() => {
    if (state.errorMessage) {
      dispatch(showMessageBox(null, state.errorMessage))
      localDispatch.resetState()
    }
  }, [state.errorMessage])

  const header = (
    <CustomDataTableHeader onChange={localDispatch.onInputFilter}>
      <div style={{ paddingLeft: '4px', display: 'inline' }}>
        <Btn onClick={() => localDispatch.onBtnExportarExcelClick(state.transportadoras)}>
          Exportar
        </Btn>
      </div>
    </CustomDataTableHeader>
  )

  return (
    <div>
      <PageHeader>2.9 - Transportadoras</PageHeader>
      <div style={{ marginTop: 20 }}>
        <CustomPanel
          onNovo={() => localDispatch.onBtnNovo(selectedTp)}
          onVoltar={() => history.goBack()}
        >
          <DataTable
            value={state.transportadoras}
            paginator={true}
            rows={10}
            header={header}
            globalFilter={state.globalFilter}
            emptyMessage={'Sem transportadoras cadastradas'}
            style={state.transportadoras.length === 0 ? { textAlign: 'center' } : {}}
          >
            <Column field="id" header="Código" style={tableCellCentered(80)} />
            <Column field="nome" header="Nome" />
            <Column
              field="cnpj"
              header="CNPJ"
              body={(transportadora, column) => <Cnpj>{transportadora.cnpj}</Cnpj>}
            />
            <Column field="city" header="Cidade" />
            <Column field="state" header="Estado" />
            <Column
              field="actived"
              header="Ativo"
              style={{ textAlign: 'center', width: 100 }}
              body={(rowData, column) => <CustomCheckbox disabled checked={rowData.actived} />}
            />
            <Column
              header="Menu"
              style={tableCellCentered(70)}
              body={transportadora => (
                <ThreeDots
                  items={['Editar', 'Apagar']}
                  onClick={item => localDispatch.onMenuItemClicked(item, transportadora)}
                />
              )}
              bodyStyle={tableCellCentered()}
            />
          </DataTable>
        </CustomPanel>
      </div>
      <TransportadoraModal
        onModalClose={localDispatch.onModalClose}
        onModalSave={localDispatch.onModalSave}
        transportadora={state.selectedTransportadora}
        visible={state.showModal}
      />
    </div>
  )
}

const mapStateToProps = ({ system: { selectedTp } }) => ({ selectedTp })
export default connect(mapStateToProps)(withRouter(Transportadora))
